module.exports = __webpack_public_path__ + "img/hslogo2.0efbc49c.png";